import { combineReducers } from 'redux'
import auth from './auth'
import provider from './provider'
import sidebar from './sidebar'
import toast from './toast'
import file from './file'
import bank from './bank'
import quote from './quote'
import quoteConcept from './quoteConcept'
import pendingPayments from './pendingPayments'
import department from './department'
import user from './user'
import permission from './permission'
import role from './role'
import unit from './unit'
import dropbox from './dropbox'
import payedPayments from './payedPayments'
import paymentsWithoutInvoice from './paymentsWithoutInvoice'
import cancelledPayments from './cancelledPayments'
import project from './project'
import providerHistory from './providerHistory'
import quoteProvider from './quoteProvider'
import myPayments from './myPayments'
import concept from './charge'
import budget from './budget'
import charge from './charge'
import syncNom from './syncNom'
import categoryChange from './categoryChange'
import currency from './currency'
import configuration from './configuration'
import legalNames from './legalNames'
import position from './position'
import employee from './employee'
import vacation from './vacation'
import holidayReducer from './holidayReducer'

export default combineReducers({
  auth,
  provider,
  sidebar,
  toast,
  file,
  bank,
  quote,
  quoteConcept,
  pendingPayments,
  department,
  user,
  permission,
  role,
  unit,
  dropbox,
  payedPayments,
  paymentsWithoutInvoice,
  cancelledPayments,
  project,
  providerHistory,
  quoteProvider,
  myPayments,
  concept,
  budget,
  charge,
  syncNom,
  categoryChange,
  currency,
  configuration,
  legalNames,
  position,
  employee,
  vacation,
  holidayReducer,
})
